import React, { useState } from "react";
import Image from "next/image";
import axios from "axios";
import { toast } from "react-hot-toast";
import { BASE_URL } from "@/util/api";

const NewsLetter = () => {
    const [message, setMessage] = useState({
        name: "",
        email: "",
    });

    const [errors, setErrors] = useState({
        name: "",
        email: "",
    });

    // Regex for validation
    const nameRegex = /^[a-zA-Z\s]+$/; // Only A-Z and spaces
    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/; // Email pattern

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const { name, value } = e.target;
        setMessage({ ...message, [name]: value });

        // Validation
        if (name === "name") {
            setErrors({ ...errors, name: nameRegex.test(value) ? "" : "Only A-Z characters allowed" });
        } else if (name === "email") {
            setErrors({ ...errors, email: emailRegex.test(value) ? "" : "Invalid email format" });
        }
    };

    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault();

        // Final validation before submission
        if (!message.name || !nameRegex.test(message.name)) {
            setErrors((prev) => ({ ...prev, name: "Only A-Z characters allowed" }));
            return;
        }
        if (!message.email || !emailRegex.test(message.email)) {
            setErrors((prev) => ({ ...prev, email: "Invalid email format" }));
            return;
        }

        try {
            await axios.post(`${BASE_URL}subscription/`, message);
            toast.success("Message sent successfully");
            setMessage({ name: "", email: "" });
            setErrors({ name: "", email: "" }); // Clear errors after successful submit
        } catch (error: any) {
            toast.error(error?.response?.data?.email || "Something went wrong!");
        }
    };

    return (
        <div className="w-full py-12">
            <div className="w-full px-4">
                <div className="w-full lg:w-[95%] 2xl:w-[77%] mx-auto bg-blue rounded-2xl flex gap-4 flex-col md:flex-row justify-around items-center py-10 px-6 shadow-lg">
                    <Image src="/images/priya/girlbanner.svg" alt="Girl" height={239} width={321} />
                    <div className="text-white text-center lg:w-1/2 max-w-[609px] sm:text-left">
                        <h2 className="text-2xl font-semibold">Don’t Miss Updates From Us!</h2>
                        <p className="text-sm mt-5">
                            Sign up now for our newsletter to receive a list of newly added high DA sites and limited-time offers every week.
                        </p>
                        <form onSubmit={handleSubmit} className="mt-4 flex flex-col sm:flex-row items-center gap-2">
                            <div>

                            <div className="flex flex-wrap gap-4">
                                <div className="">
                                    <input
                                        type="text"
                                        name="name"
                                        value={message.name}
                                        onChange={handleChange}
                                        placeholder="Your Name"
                                        className="sm:w-64 px-4 py-2 rounded-md border border-gray-300 text-black focus:outline-none"
                                        required
                                    />
                                    {errors.name && <p className="text-red-500 text-xs mt-1">{errors.name}</p>}
                                </div>
                                <div className="flex flex-col">
                                    <input
                                        type="email"
                                        name="email"
                                        value={message.email}
                                        onChange={handleChange}
                                        placeholder="E-mail Address"
                                        className="sm:w-64 px-4 py-2 rounded-md border border-gray-300 text-black focus:outline-none"
                                        required
                                    />
                                    {errors.email && <p className="text-red-500 text-xs mt-1">{errors.email}</p>}
                                </div>
                            </div>
                            <button
                                type="submit"
                                className="px-6 mt-4 py-2 bg-white text-pink hover:bg-pink hover:text-white font-semibold rounded-md disabled:opacity-50 disabled:cursor-not-allowed"
                                disabled={!!errors.name || !!errors.email}
                            >
                                Subscribe Now
                            </button>
                            </div>

                        </form>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default NewsLetter;
